import { fetchCustomPageData } from '../api';
import { FETCH_CUSTOM_PAGE_URL } from '../const';
import { useDataQuery } from '@packages/dataQuery';
import { CustomPagePath, CustomPageWidgets } from '../types';
import { useStoragePerUserData } from '../../user';
import { LocalStorageKeys } from '../../../utils/storageManager';
import { isNull } from '../../../predicates/type';
import isArray from 'lodash/isArray';

const DEFAULT_DATA: CustomPageWidgets = [];

function isValidData(data: CustomPageWidgets | null) {
	return !isNull(data) && isArray(data);
}

export function useCustomPageDataQuery(path: CustomPagePath) {
	const { data, setData } = useStoragePerUserData<CustomPageWidgets>(`${LocalStorageKeys.CustomPage}_${path}`);

	const dataQuery = useDataQuery([FETCH_CUSTOM_PAGE_URL], () => fetchCustomPageData(path), {
		placeholderData: () => {
			if (isValidData(data)) {
				return data;
			}
		},
		onSuccess: (newData) => {
			if (isValidData(newData)) {
				setData(newData);
			}
		},
		staleTime: 2000,
	});

	return {
		...dataQuery,
		data: dataQuery.data || DEFAULT_DATA,
	};
}
